/* -------------------------
   FREE SHIPPING PROGRESS BAR
-------------------------- */

function updateFreeShippingBar(cart) {
  const wrapper = document.querySelector('#free-shipping-progress');
  if (!wrapper) return;

  const goal = Number(wrapper.dataset.goal);
  const subtotal = cart.items_subtotal_price; // in cents

  const msg = wrapper.querySelector('.fsp-message');
  const fill = wrapper.querySelector('.fsp-fill');

  const percent = Math.min((subtotal / goal) * 100, 100);
  fill.style.width = percent + "%";

  if (subtotal >= goal) {
    msg.innerHTML = "🎉 You unlocked <strong>FREE SHIPPING</strong>!";
  } else {
    const remain = ((goal - subtotal) / 100).toFixed(2);
    msg.textContent = `Add $${remain} more for Free Shipping`;
  }
}

/* ---- Trigger when cart drawer updates ---- */
document.addEventListener('cartDrawer:updated', (event) => {
  updateFreeShippingBar(event.detail.cart);
});

/* ---- Initial load ---- */
document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateFreeShippingBar(cart));
});
